"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var discardAppearanceOption_1 = require("./actions/discardAppearanceOption");
var saveAppearanceOption_1 = require("./actions/saveAppearanceOption");
var AppearanceFull_1 = require("./components/AppearanceFull");
var isAppearanceOptionDirty_1 = require("./utils/isAppearanceOptionDirty");
var React = require("react");
var AppearanceOption = {
    key: 'appearance',
    titleStringKey: 'optionTitle_appearance',
    searchTermsStringKey: 'optionTitle_appearance',
    fullOptionFormSettings: {
        render: function () { return React.createElement(AppearanceFull_1.default, null); },
        isDirty: isAppearanceOptionDirty_1.default,
        onSave: saveAppearanceOption_1.default,
        onDiscard: discardAppearanceOption_1.default,
    },
};
exports.default = AppearanceOption;
//# sourceMappingURL=AppearanceOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/calendar/owa-calendar-appearance-option/lib/AppearanceOption.js
// module id = 5259
// module chunks = 2